import * as React from 'react';
import {FormattedMessage} from "react-intl";
import {Button, Divider} from "@mui/material";
import "./index.css";
import {Language} from "../../../../modules/common/enums/Language";
import {useContext, useEffect, useState} from "react";
import {LanguageContext} from "../../../../context/LanguageContext";
import {useNavigate} from "react-router-dom";
import {RoutePath} from "../../../../constants/RoutePath";
import {UserApi} from "../../../../modules/account/api/UserApi";
import {HttpStatus} from "../../../../modules/common/enums/HttpStatus";
import {UserDto} from "../../../../modules/account/dto/UserDto";
import SessionUserDialog from "./components/SessionUserDialog";
import LoginDialog from "../../../account/user/login/components/LoginDialog";
import {WECHAT_APP_ID, WECHAT_AUTH_DOMAIN, WECHAT_AUTH_PAGE} from "../../../../constants/Profile";

export default function Index() {

    const navigate = useNavigate();
    // 多语言上下文设置
    const {language, setLanguage} = useContext(LanguageContext);

    useEffect(() => {
    }, []);

    const _handleChangeLanguage = (value: string) => {
        setLanguage(value);
    }

    const _handleSelfRegister = () => {
        const redirectUri = encodeURIComponent(WECHAT_AUTH_DOMAIN + "/" + WECHAT_AUTH_PAGE);
        const state = encodeURIComponent(RoutePath.VMS_MOBILE_VISITOR_SELF_REGISTER);
        // navigate(RoutePath.VMS_MOBILE_VISITOR_SELF_REGISTER)
        window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + WECHAT_APP_ID + "&redirect_uri=" + redirectUri + "&response_type=code&scope=snsapi_userinfo&state=" + state + "#wechat_redirect";
    }
    const _handleEmployeeRegister = () => {
        const redirectUri = encodeURIComponent(WECHAT_AUTH_DOMAIN + "/" + WECHAT_AUTH_PAGE);
        const state = encodeURIComponent(RoutePath.VMS_MOBILE_EMPLOYEE_REGISTER);
        // navigate(RoutePath.VMS_MOBILE_VISITOR_SELF_REGISTER)
        window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + WECHAT_APP_ID + "&redirect_uri=" + redirectUri + "&response_type=code&scope=snsapi_userinfo&state=" + state + "#wechat_redirect";
    }


    const _handleEmployeeHome = () => {
        const redirectUri = encodeURIComponent(WECHAT_AUTH_DOMAIN + "/" + WECHAT_AUTH_PAGE);
        const state = encodeURIComponent(RoutePath.VMS_MOBILE_EMPLOYEE_HOME);
        // navigate(RoutePath.VMS_MOBILE_VISITOR_SELF_REGISTER)
        window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + WECHAT_APP_ID + "&redirect_uri=" + redirectUri + "&response_type=code&scope=snsapi_userinfo&state=" + state + "#wechat_redirect";
    }
    const _handleVisitHistory = () => {
        const redirectUri = encodeURIComponent(WECHAT_AUTH_DOMAIN + "/" + WECHAT_AUTH_PAGE);
        const state = encodeURIComponent(RoutePath.VMS_MOBILE_VISITOR_HISTORY);
        // navigate(RoutePath.VMS_MOBILE_VISITOR_SELF_REGISTER)
        window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + WECHAT_APP_ID + "&redirect_uri=" + redirectUri + "&response_type=code&scope=snsapi_userinfo&state=" + state + "#wechat_redirect";
    }
    return (
        <div className={'mobile-welcome-background'}>
            {/*头部区域*/}
            <div className={"mobile-welcome-header"}>
                <img alt={'vms'} src={'/logo.png'}/>
                <div className={"mobile-welcome-header-title"}>
                    <FormattedMessage id='VMS_TERMINAL_WELCOME_TITLE'/>
                </div>
            </div>

            {/*操作区域内容*/}
            <div className="mobile-welcome-operation-panel">
                <div className={"mobile-welcome-operation-main"}>
                    <Button variant="contained" fullWidth={true}
                            onClick={() => _handleEmployeeRegister()}>
                        <FormattedMessage id='VMS_MOBILE_WELCOME_EMPLOYEE_REGISTER'/>
                    </Button>
                    <Button variant="contained" fullWidth={true}
                            onClick={() => _handleSelfRegister()}>
                        <FormattedMessage id='VMS_MOBILE_WELCOME_SELF_REGISTER'/>
                    </Button>
                    <Button variant="contained" fullWidth={true} onClick={() => _handleEmployeeHome()}>
                        <FormattedMessage id='VMS_MOBILE_WELCOME_SELF_EMPLOYEE_ENTRANCE'/>
                    </Button>
                    <Button variant="text" className={"operation-link"} fullWidth={true}  onClick={() => _handleVisitHistory()}>
                        <FormattedMessage id='VMS_VISITOR_REQUEST_HISTORY'/>
                    </Button>
                </div>
                <div className='mobile-welcome-operation-language'>
                    <Divider textAlign="left"><span className={'mobile-welcome-operation-language-title'}>选择语言 / Language&nbsp;selection</span></Divider>
                    <div className="mobile-welcome-language-button-panel">
                        <Button variant="contained" onClick={() => _handleChangeLanguage(Language.Enum.enUS)}>
                            <FormattedMessage id={Language.Map.get("en-US")}/>
                        </Button>
                        <Button variant="contained" onClick={() => _handleChangeLanguage(Language.Enum.zhCN)}>
                            <FormattedMessage id={Language.Map.get("zh-CN")}/>
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    )
}